// @ts-nocheck
import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const RankingBottomPanelStyle = styled.div`
  .mapRankingBottomPanel {
    &__box {
      box-shadow: 0 -1.3px 13px 0 rgba(18, 22, 30, 0.05);
    }

    &__boxBody {
      width: 100%;
      margin-bottom: 0;
    }

    &__rankings {
      margin-top: 16px;
      display: flex;
      gap: 16px;
      height: 600px;
    }
    &__mapRanking {
      flex: 1;
      height: 100%;
      padding: 16px;
      overflow: hidden;
      overflow-y: auto;
      ${mixins.forceScrollbar}
      background-color: ${props => props.theme.uiColors.background01};

      .reportingInsightsItem__filters {
        margin-top: 0 !important;
      }

      &:first-child {
        margin-left: 16px;
      }
      &:last-child {
        margin-right: 16px;
      }
    }
  }
  .reportingInsightsRankingItem__insightChartItemWrapper{
    height: calc(100% - 40px);
  }
  .insightsChartItem__contentWrapper {
    height: calc(100% - 106px);
  }
`;
